module.exports = __webpack_public_path__ + "img/call-res.b243fd87.svg";